import Link from "./Link";

export type { ILinkProps } from "./Link";

export default Link;
